import { render, staticRenderFns } from "./ArticleItemDetail.vue?vue&type=template&id=139314cc&"
import script from "./ArticleItemDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports